export function getRiskBadgeClass(score) {
    if (score === undefined || score === null) {
        return "bg-gray-100 text-gray-600 dark:bg-slate-700 dark:text-slate-300";
    }

    if (score <= 25) {
        return "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300";
    }

    if (score <= 50) {
        return "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/40 dark:text-yellow-300";
    }

    return "bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300";
}

export function getRiskBadgeLabel(score) {
    if (score === undefined || score === null) {
        return "Sem score";
    }

    if (score <= 25) {
        return "Risco alto";
    }

    if (score <= 50) {
        return "Risco médio";
    }

    return "Risco baixo";
}

export function getRiskTextClass(score) {
    if (score === undefined || score === null) {
        return "text-gray-600 dark:text-slate-300";
    }

    if (score <= 25) {
        return "text-red-500";
    }

    if (score <= 50) {
        return "text-yellow-500";
    }

    return "text-green-500";
}

export function getUserInitials(name = "") {
    return name
        .split(" ")
        .filter(Boolean)
        .map((part) => part[0])
        .join("")
        .slice(0, 2)
        .toUpperCase() || "?";
}

export function buildCommissionSummary(commissionTypes = {}, formatFn) {
    const entries = Object.entries(commissionTypes);

    if (!entries.length) {
        return "Sem comissões cadastradas";
    }

    const topCommission = entries
        .map(([type, info]) => ({
            type,
            total: info.total ?? info.amount ?? 0,
        }))
        .sort((a, b) => b.total - a.total)[0];

    if (!topCommission) {
        return `${entries.length} tipos de comissão`;
    }

    const formattedType = formatFn
        ? formatFn(topCommission.type)
        : topCommission.type;

    return `${entries.length} tipos • principal ${formattedType}`;
}
